import {Typography} from '@mui/material'
import Box from '@mui/material/Box'
import Chip from '@mui/material/Chip'
import Stack from '@mui/material/Stack'
import {indigo} from '@mui/material/colors'
import React from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {updateSavedSearch} from 'redux/actions/savedSearchActions'
import {selectSavedSearchSlice} from 'redux/selectors/savedSearchSelector'
import {AppDispatch} from 'redux/store'
type Props = {
  stackVertical?: boolean
}

export default function KeywordList({stackVertical}: Props): React.ReactElement {
  const dispatch = useDispatch<AppDispatch>()
  const savedSearchRedux = useSelector(selectSavedSearchSlice)

  const handleDelete = (keyword: string) => {
    if (!savedSearchRedux.savedSearch || !savedSearchRedux.savedSearch.id) {
      return
    }

    dispatch(
      updateSavedSearch({
        id: savedSearchRedux.savedSearch.id,
        data: {
          keywords: savedSearchRedux?.savedSearch?.keywords?.filter((x) => x !== keyword),
        },
        originalSavedSearch: savedSearchRedux?.savedSearch,
      })
    )
  }

  return (
    <>
      <Typography variant='caption'>
        <Stack direction={stackVertical ? 'column' : 'row'} spacing={1} flexWrap={'wrap'}>
          {savedSearchRedux.savedSearch?.keywords?.map((kw, idx) => {
            return (
              <Box display={'inline-flex'} key={idx}>
                <Chip
                  key={idx}
                  onDelete={() => handleDelete(kw)}
                  label={kw}
                  sx={{
                    mt: 0.5,
                    mb: 0.5,
                    bgcolor: 'default',
                    '& .MuiChip-deleteIcon': {
                      color: indigo[300],
                      fontSize: '1.3rem',
                    },
                    '& .MuiChip-label': {
                      fontSize: '1rem',
                    },
                  }}
                />
              </Box>
            )
          })}
        </Stack>
      </Typography>
    </>
  )
}
